import "core-js/modules/es6.object.define-properties";
import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.array.for-each";
import "core-js/modules/es6.array.filter";
import "core-js/modules/es6.object.define-property";
import "core-js/modules/es6.object.assign";
import "core-js/modules/es6.promise";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.array.index-of";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "regenerator-runtime/runtime";
import _isEmpty from "lodash/isEmpty";
import _get from "lodash/get";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useContext, useCallback } from 'react';
import PropTypes from 'prop-types';
import analyticsModule from '@nerdwallet/analytics';
import { ImpressionContext, useImpression } from '@nerdwallet/analytics/react/impression';
import { Tab } from '@nerdwallet/react-tabs';
import { MORE_DETAILS } from './lib/constants';
import { buildAnalyticsEntityName } from './lib/utils';

var concatPropKey = function concatPropKey(elementName, _ref) {
  var label = _ref.label;

  if (label) {
    return buildAnalyticsEntityName("".concat(elementName, "_").concat(label));
  }

  return elementName;
};

var AnalyticsTabImpression = function AnalyticsTabImpression(_ref2) {
  var analytics = _ref2.analytics,
      children = _ref2.children,
      onClick = _ref2.onClick,
      onTabClick = _ref2.onTabClick,
      props = _objectWithoutProperties(_ref2, ["analytics", "children", "onClick", "onTabClick"]);

  var entityName = analytics.entityName,
      eventType = analytics.eventType,
      payload = analytics.payload,
      onClickProps = analytics.onClickProps,
      onTabClickProps = analytics.onTabClickProps;
  var impressionContext = useContext(ImpressionContext);

  var _useImpression = useImpression({
    eventType: eventType || 'element_impression',
    entityName: buildAnalyticsEntityName(entityName || MORE_DETAILS),
    payload: {
      parent_impression_id: (impressionContext === null || impressionContext === void 0 ? void 0 : impressionContext.impressionId) || null,
      section_name: _get(payload, 'section_name', MORE_DETAILS),
      section_position: _get(payload, 'section_position', 1)
    }
  }),
      ref = _useImpression.ref,
      impression = _objectWithoutProperties(_useImpression, ["ref"]);

  var internalOnTabClick = useCallback(function () {
    var elementName = concatPropKey("".concat(MORE_DETAILS, "_tab_click"), props);
    analyticsModule.track('element_interacted', {
      action: 'expand',
      entity_name: buildAnalyticsEntityName( // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
      (payload === null || payload === void 0 ? void 0 : payload.elementName) || (onTabClickProps === null || onTabClickProps === void 0 ? void 0 : onTabClickProps.entityName)) || elementName,
      impression_id: impression === null || impression === void 0 ? void 0 : impression.impressionId,
      interaction_type: 'press'
    });
    onTabClick === null || onTabClick === void 0 ? void 0 : onTabClick();
  }, // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  [onTabClick, impression]);
  var internalOnClick = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
    var elementName;
    return regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            elementName = concatPropKey("".concat(MORE_DETAILS, "_click"), props);
            _context.next = 3;
            return analyticsModule.track('element_interacted', {
              action: 'expand',
              entity_name: buildAnalyticsEntityName( // eslint-disable-next-line react/prop-types -- directive added automatically by Shepherd migration
              (payload === null || payload === void 0 ? void 0 : payload.elementName) || (onClickProps === null || onClickProps === void 0 ? void 0 : onClickProps.entityName)) || elementName,
              impression_id: impression === null || impression === void 0 ? void 0 : impression.impressionId,
              interaction_type: 'press'
            });

          case 3:
            _context.next = 5;
            return analyticsModule.flush();

          case 5:
            onClick === null || onClick === void 0 ? void 0 : onClick();

          case 6:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  })), // eslint-disable-next-line react-hooks/exhaustive-deps -- directive added automatically by Shepherd migration
  [onClick, impression]);
  return /*#__PURE__*/React.createElement(Tab, _extends({}, props, {
    onClick: internalOnClick,
    onTabClick: internalOnTabClick,
    ref: ref
  }), /*#__PURE__*/React.createElement(ImpressionContext.Provider, {
    value: impression
  }, children));
};

AnalyticsTabImpression.propTypes = {
  analytics: PropTypes.shape({
    entityName: PropTypes.string,
    eventType: PropTypes.string,
    onClickProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    onTabClickProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    payload: PropTypes.shape({
      section_name: PropTypes.string,
      section_position: PropTypes.string
    })
  }),
  children: PropTypes.node,
  onClick: PropTypes.func,
  onTabClick: PropTypes.func
};

var TabImpression = function TabImpression(_ref4) {
  var analytics = _ref4.analytics,
      children = _ref4.children,
      onClick = _ref4.onClick,
      onTabClick = _ref4.onTabClick,
      props = _objectWithoutProperties(_ref4, ["analytics", "children", "onClick", "onTabClick"]);

  if (_isEmpty(analytics)) {
    return /*#__PURE__*/React.createElement(Tab, _extends({}, props, {
      onClick: onClick,
      onTabClick: onTabClick
    }), children);
  }

  return /*#__PURE__*/React.createElement(AnalyticsTabImpression, _extends({
    analytics: analytics,
    onClick: onClick,
    onTabClick: onTabClick
  }, props), children);
};

TabImpression.propTypes = _objectSpread(_objectSpread({}, Tab.propTypes), {}, {
  analytics: PropTypes.shape({
    entityName: PropTypes.string,
    eventType: PropTypes.string,
    onClickProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    onTabClickProps: PropTypes.shape({
      entityName: PropTypes.string
    }),
    payload: PropTypes.shape({
      section_name: PropTypes.string,
      section_position: PropTypes.string
    })
  })
});
TabImpression.defaultProps = _objectSpread(_objectSpread({}, Tab.defaultProps), {}, {
  analytics: {}
});
export default TabImpression;